import { makeStyles } from 'transfix-ui/core'

export const useContactInfoFormSectionStyles = makeStyles(() => ({
  phone: {
    '& .text-input-container': {
      minWidth: 'auto !important',
      height: `34px !important`,
    },
  },
}))
